import axios from 'axios'

const itsApi = axios.create({
	baseURL: process.env.VUE_APP_ITS_URL,
	headers: {
		'Accept': 'application/json',
      	'Content-Type': 'application/json'
	},
	transformRequest: [(data, headers) => {
		// ITS is a separate service and must not receive the app's
		// Authorization header. axios 1.x passes an AxiosHeaders instance
		// here (no .common/.get/.post buckets), so strip Authorization
		// directly off the instance.
		if (headers) {
			if (typeof headers.delete === 'function') headers.delete('Authorization')
			else delete headers.Authorization
		}
		return JSON.stringify(data)
	}]
})

export default itsApi